
import { Model } from 'backbone';

class ActionDetailsModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default ActionDetailsModel;
